import { render } from "./HeaderLogo.vue?vue&type=template&id=397c3d00&scoped=true"
const script = {}

import "./HeaderLogo.vue?vue&type=style&index=0&id=397c3d00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397c3d00"]])

export default __exports__